import React from "react";
import clsx from "clsx";
import { Text } from "@jasperlabs/ui";

type EmptyStateProps = {
	emptyTitle: string;
	emptyMessage?: string;
};

const EmptyState = ({
	emptyTitle,
	emptyMessage,
	...rest
}: React.ComponentPropsWithoutRef<"div"> & EmptyStateProps) => (
	<div
		{...rest}
		className="flex flex-col items-center justify-center text-center"
	>
		<Text
			as="h4"
			variant="subheading-default"
			className="text-neutral-500 mb-3"
		>
			{emptyTitle}
		</Text>
		{emptyMessage && (
			<Text variant="body-default" className="text-color-body-text">
				{emptyMessage}
			</Text>
		)}
	</div>
);

const CenteredLayout = ({
	className,
	children,
}: {
	className?: string;
	children: React.ReactNode;
}) => (
	<div
		className={clsx(
			"flex h-full w-full flex-col items-center justify-center",
			className,
		)}
	>
		{children}
	</div>
);

EmptyState.CenteredLayout = CenteredLayout;

export default EmptyState;
